import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledMenuCloseAction = styled.div`
  ${({ theme }) => `
    width: ${utils.rem(theme.Spacing.Size.Medium)};
    height: ${utils.rem(3)};
    border-radius: ${utils.rem(theme.Spacing.Size.Small)};
    background: ${theme.Color.Neutrals.Gray};
  `}
`;
